export const defaultPostMeetingMessage = {
    slate: [
        {
            "children": [
                {
                    "text": ""
                }
            ],
            "id": "6jluo",
            "type": "p",
            "align": "center"
        },
        {
            "children": [
                {
                    "text": ""
                }
            ],
            "id": "qvm5p",
            "type": "p",
            "align": "center"
        },
        {
            "children": [
                {
                    "text": ""
                }
            ],
            "id": "goe2d",
            "type": "p",
            "align": "center"
        },
        {
            "children": [
                {
                    "text": ""
                }
            ],
            "id": "bngzo",
            "type": "p",
            "align": "center"
        },
        {
            "children": [
                {
                    "text": "This meeting has ended. A recording of this meeting will be available shortly in My Meeting under the Past Tab."
                }
            ],
            "id": "2fu4n",
            "type": "p",
            "align": "center"
        }
    ]
};
//# sourceMappingURL=constants.js.map